<form *ngIf="contractFormGroup" [formGroup]="contractFormGroup">
  <p-card class="p-3" header="Datos generales">
    <div class="grid">
      <div class="col-3 input-field">
        <label for="name">Nombre *</label>
        <input pInputText name="name" formControlName="name" d-form-field-error />
      </div>
      <div class="col-3 input-field">
        <label for="code">Código *</label>
        <input pInputText name="code" formControlName="code" d-form-field-error />
      </div>
      <div class="col-2 input-field ">
        <label for="startDate">Desde</label>
        <p-calendar [firstDayOfWeek]="1" inputId="startDate" appendTo="body" dateFormat="dd/mm/yy"
          formControlName="startDate" d-form-field-error />
      </div>
      <div class="col-2 input-field ">
        <label for="endDate">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" inputId="endDate" appendTo="body" dateFormat="dd/mm/yy"
          formControlName="endDate" d-form-field-error />
      </div>
      <div class="col-2 input-field">
        <label for="target">Tipo de destinatario</label>
        <p-dropdown inputId="target" [options]="targetOptions" optionLabel="name" optionValue="id"
          formControlName="target" appendTo="body" d-form-field-error />
      </div>
    </div>
    
    <div class="p-card-title mt-4 mb-3"> Delegado del contrato </div>

     <div class="grid">
      <div class="col-3 input-field">
        <label for="contactName">Nombre</label>
        <input pInputText name="contactName" formControlName="contactName" d-form-field-error />
      </div>
      <div class="col-3 input-field">
        <label for="contactPhone1">Teléfono</label>
        <input pInputText name="contactPhone1" formControlName="contactPhone1" d-form-field-error />
      </div>
      <div class="col-6 input-field">
        <label for="contactEmail">Email</label>
        <input pInputText name="contactEmail" formControlName="contactEmail" d-form-field-error />
      </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
      <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
        (click)="delete()"></p-button>
      <div class="flex-grow-1"></div>
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
  </p-card>
  <p-tabView  (onChange)="onTabChange($event)">
    <p-tabPanel header="Configuración">
      <p-card class="p-3" header="Expedientes">
        <div class="grid">
          <div class="col-3 input-field">
            <label for="name">Prefijo</label>
            <input pInputText name="case_prefix" formControlName="case_prefix" d-form-field-error />
          </div>
          <div class="col-3 input-field">
            <label for="enableCaseNumberGenerate">Generar id expediente automáticamente</label>
            <p-inputSwitch formControlName="enableCaseNumberGenerate" d-form-field-error></p-inputSwitch>
          </div>
          <div class="col-3 input-field">
            <label for="sendCaseTracking">Envío automático de sigue tu expediente</label>
            <p-dropdown formControlName="sendCaseTracking" [options]="caseTrackingChannels"
                optionLabel="label" optionValue="value" appendTo="body" d-form-field-error></p-dropdown>
          </div>
          <div class="col-3 input-field">
            <label for="sendVideoReportFlow">Comunicar videoperitación automáticamente</label>
            <p-inputSwitch formControlName="sendVideoReportFlow" d-form-field-error></p-inputSwitch>
          </div>
        </div>
        <div class="grid">
          <div class="col-3 input-field">
            <label for="name">% rentabilidad mínimo</label>
            <p-inputNumber name="profitMinPercent" [min]="0" [max]="100" formControlName="profitMinPercent"
              [required]="true" d-form-field-error />
          </div>
          <div class="col-3 input-field">
            <label for="name">% rentabilidad deseado</label>
            <p-inputNumber name="profitDesiredPercent" [min]="contractFormGroup.get('profitMinPercent')?.value"
              [max]="100" formControlName="profitDesiredPercent" [required]="true" d-form-field-error />
          </div>
          <div class="col-3 input-field">
            <label for="name">Responsable</label>
            <p-dropdown name="responsibleUserId" [options]="users" optionLabel="name" optionValue="id" showClear
              [filter]="true" filterBy="name" placeholder="Seleccione un responsable" appendTo="body" (onFilter)="loadUsers($event)"
               formControlName="responsibleUserId" d-form-field-error />
          </div>
          
          <div class="col-3 input-field">
            <label for="name">Segundo Responsable</label>
            <p-dropdown name="secondResponsibleUserId" [options]="users" optionLabel="name" optionValue="id" showClear
              [filter]="true" filterBy="name" placeholder="Seleccione un segundo responsable" appendTo="body" (onFilter)="loadUsers($event)"
               formControlName="secondResponsibleUserId" d-form-field-error />
          </div>
        </div>
        <div class="grid">
          <div class="col-3 input-field">
            <label for="urgentPlusReminder">Recordatorio de plus de urgencia</label>
            <p-inputSwitch formControlName="urgentPlusReminder" d-form-field-error></p-inputSwitch>
          </div>
        </div>
      </p-card>
      <p-card class="p-3 mt-4" header="Facturación">
        <div class="grid">
          <div class="col input-field">
            <label for="name">Sociedad *</label>
            <p-dropdown name="billingCompanyId" [options]="billingCompanies" optionLabel="name" optionValue="id"
              [filter]="true" filterBy="name" placeholder="Seleccione sociedad" appendTo="body"
              (onChange)="onChangeCompany($event)" formControlName="billingCompanyId" d-form-field-error />
          </div>
          <div class="col input-field">
            <label for="name">Cuenta bancaria</label>
            <p-dropdown name="billingCompanyBankAccountId" [options]="billingCompaniesBanksAccounts"
              optionLabel="accountNumber" optionValue="id" [filter]="true" filterBy="accountNumber"
              placeholder="Seleccione cuenta bancaria" appendTo="body" formControlName="billingCompanyBankAccountId"
              d-form-field-error />
          </div>
          <div class="col input-field">
            <label for="name">Forma de pago</label>
            <p-dropdown name="paymentMethodId" [options]="paymentsMethods" optionLabel="name" optionValue="id"
              [filter]="true" filterBy="name" placeholder="Seleccione forma de pago" appendTo="body"
              formControlName="paymentMethodId" d-form-field-error />
          </div> 
          <div class="col input-field">
            <label for="paymentDuedateDays">Dias de vencimiento</label>
            <p-inputNumber name="paymentDuedateDays" formControlName="paymentDuedateDays" id="paymentDuedateDays" [min]="0"
              d-form-field-error />
          </div>
        </div>
        <div class="grid">
          <div class="col input-field">
            <label for="budgeDiscount">Descuento a aplicar en presupuesto</label>
            <p-inputNumber name="budgeDiscount" formControlName="budgeDiscount" [min]="0" [max]="100" suffix="%"
              d-form-field-error />
          </div>
          <div class="col input-field">
            <label for="invoiceDiscount">Descuento a aplicar en factura</label>
            <p-inputNumber name="invoiceDiscount" formControlName="invoiceDiscount" [min]="0" [max]="100" suffix="%"
              d-form-field-error />
          </div>
          <div class="col input-field">
            <label for="invoiceRetentionPercent">Retención de obra</label>
            <p-inputNumber name="invoiceRetentionPercent" formControlName="invoiceRetentionPercent" [min]="0" [max]="100" suffix="%"
              d-form-field-error />
          </div>
          <div class="col input-field">
            <label for="invoiceRetentionDays">Días de retención</label>
            <p-inputNumber name="invoiceRetentionDays" formControlName="invoiceRetentionDays" [min]="0"
              d-form-field-error />
          </div>
        </div>
        <div class="grid">
          <div class="col input-field">
            <label for="jobCompanyDiscountPercent">Descuento en trabajo a compañía (%)</label>
              <input formControlName="jobCompanyDiscountPercent" name="jobCompanyDiscountPercent" pInputText type="number" d-form-field-error  [min]="0" [max]="100" >
          </div>
          <div class="col input-field">
            <label for="jobGuardCompanyIncrementPercent">Incremento de guardia (%)</label>
            <!--<p-inputNumber name="jobGuardCompanyIncrementPercent" formControlName="jobGuardCompanyIncrementPercent" [min]="0" [max]="100" suffix="%"
              d-form-field-error />-->
            <input formControlName="jobGuardCompanyIncrementPercent" name="jobGuardCompanyIncrementPercent" pInputText type="number" d-form-field-error  [min]="0" [max]="100" >
          </div>
          <div class="col input-field">
            <label for="name">Centro de coste *</label>
            <p-dropdown name="costCenterId" [options]="costsCenters" optionLabel="name" optionValue="id"
              [filter]="true" filterBy="name" placeholder="Seleccione centro de coste" appendTo="body"
              formControlName="costCenterId" d-form-field-error [required]="true" />
          </div>
       
          <div class="col input-field">
            <label for="name">Modo de facturación</label>
            <p-dropdown name="icon" [options]="invoiceModes" optionLabel="name" optionValue="id"
              [filter]="true" filterBy="name" placeholder="Seleccione" appendTo="body"
              formControlName="invoiceMode" d-form-field-error />
          </div>
        </div>
        <div class="grid">
          <div class="col-3 input-field">
            <label for="allowBillIfNotClosed">Permitir facturar si no está cerrado</label>
            <p-inputSwitch formControlName="allowBillIfNotClosed" d-form-field-error></p-inputSwitch>
          </div>
          <div class="col-3 input-field">
            <label for="allowPartialBill">Permitir facturar parcialmente</label>
            <p-inputSwitch formControlName="allowPartialBill" d-form-field-error></p-inputSwitch>
          </div>
        </div>
      </p-card>
      <p-card class="p-3 mt-4" styleClass="p-card-content-no-padding p-card-header-pb-0 p-card-body-pt-0 p-card-body-pb-0">
        <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
            <div class="p-card-title">Series de facturación</div>
            <div class="flex-grow-1"></div>
            <p-button label="Añadir serie" *ngIf="allowWrite" icon="pi pi-plus" (click)="editContractTransactionSerie(null)"></p-button>
          </div>
        </ng-template>
        <div>
          <p-table styleClass="mt-2" #grid [value]="contractTransactionSeries" [paginator]="true" [rows]="25"
            [totalRecords]="totalTransactionSeriesRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="transactionSerie.name">Nombre <p-sortIcon field="transactionSerie.name"></p-sortIcon></th>
                <th pSortableColumn="transactionSerie.prefix">Prefijo <p-sortIcon field="transactionSerie.prefix"></p-sortIcon></th>
                <th pSortableColumn="transactionSerie.returnPrefix">Prefijo de abono <p-sortIcon field="transactionSerie.returnPrefix"></p-sortIcon></th>
                <th pSortableColumn="transactionSerie.numberLength">Longitud de número <p-sortIcon field="transactionSerie.numberLength"></p-sortIcon></th>
                <th pSortableColumn="transactionSerie.firstNumber">Primer número <p-sortIcon field="transactionSerie.firstNumber"></p-sortIcon></th>
                <th pSortableColumn="transactionSerie.transactionType.name">Tipo de transacción <p-sortIcon
                      field="transactionSerie.transactionType.name"></p-sortIcon>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractTransactionSerie let-columns="columns">
              <tr (dblclick)="editContractTransactionSerie(contractTransactionSerie)">
                <td>{{contractTransactionSerie.transactionSerie.name}}</td>
                <td>{{contractTransactionSerie.transactionSerie.prefix}}</td>
                <td>{{contractTransactionSerie.transactionSerie.returnPrefix}}</td>
                <td>{{contractTransactionSerie.transactionSerie.numberLength}}</td>
                <td>{{contractTransactionSerie.transactionSerie.firstNumber}}</td>
                <td>{{contractTransactionSerie.transactionSerie.transactionType?.name}}</td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteContractTransactionSerie(contractTransactionSerie)" [rounded]="true"
                      [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editContractTransactionSerie(contractTransactionSerie)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                  <td [attr.colspan]="2">
                      No se han encontrado series
                  </td>
              </tr>
          </ng-template>
          </p-table>
        </div>
      </p-card>
      <p-card class="p-3 mt-4" styleClass="p-card-content-no-padding p-card-header-pb-0 p-card-body-pt-0 p-card-body-pb-0">
        <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
            <div class="p-card-title">Teléfonos entrantes</div>
            <div class="flex-grow-1"></div>
            <p-button label="Añadir teléfono" *ngIf="allowWrite" icon="pi pi-plus" (click)="editContractInboundPhone(null)"></p-button>
          </div>
        </ng-template>
        <div>
          <p-table styleClass="mt-2" #grid [value]="contractInboundPhones" [paginator]="true" [rows]="25"
            [totalRecords]="totalContractInboundPhonesRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="phone">Teléfono <p-sortIcon field="phone"></p-sortIcon></th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractInboundPhone let-columns="columns">
              <tr (dblclick)="editContractInboundPhone(contractInboundPhone)">
                <td>{{contractInboundPhone.phone}}</td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteContractInboundPhone(contractInboundPhone)"
                      [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editContractInboundPhone(contractInboundPhone)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </div>
      </p-card>
      <p-card class="p-3 mt-4" styleClass="p-card-content-no-padding p-card-header-pb-0 p-card-body-pt-0 p-card-body-pb-0">
        <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
            <div class="p-card-title">Teléfonos salientes</div>
            <div class="flex-grow-1"></div>
            <p-button label="Añadir teléfono saliente" *ngIf="allowWrite" icon="pi pi-plus" (click)="editContractOutboundPhone(null)"></p-button>
          </div>
        </ng-template>
        <div>
          <p-table styleClass="mt-2" #grid [value]="contractOutboundPhones" [paginator]="true" [rows]="25"
            [totalRecords]="totalContractOutboundPhonesRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="phone">Teléfono <p-sortIcon field="phone"></p-sortIcon></th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractOutboundPhone let-columns="columns">
              <tr (dblclick)="editContractOutboundPhone(contractOutboundPhone)">
                <td>{{contractOutboundPhone.phone}}</td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteContractOutboundPhone(contractOutboundPhone)"
                      [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editContractOutboundPhone(contractOutboundPhone)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </div>
      </p-card>
      <p-card class="p-3 mt-4" styleClass="p-card-content-no-padding p-card-header-pb-0 p-card-body-pt-0 p-card-body-pb-0">
        <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
            <div class="p-card-title">Emails entrantes</div>
            <div class="flex-grow-1"></div>
            <p-button label="Añadir email entrante" *ngIf="allowWrite" icon="pi pi-plus" (click)="editContractInboundMail(null)"></p-button>
          </div>
        </ng-template>
        <div>
          <p-table styleClass="mt-2" #grid [value]="contractInboundMails" [paginator]="true" [rows]="25"
            [totalRecords]="totalContractInboundMailsRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="mail">Correo electrónico <p-sortIcon field="mail"></p-sortIcon></th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractInboundMail let-columns="columns">
              <tr (dblclick)="editContractInboundMail(contractInboundMail)">
                <td>{{contractInboundMail.mail}}</td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteContractInboundMail(contractInboundMail)"
                      [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editContractInboundMail(contractInboundMail)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </div>
      </p-card>
      <p-card class="p-3 mt-4" styleClass="p-card-content-no-padding p-card-header-pb-0 p-card-body-pt-0 p-card-body-pb-0">
        <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
            <div class="p-card-title">Email salientes</div>
            <div class="flex-grow-1"></div>
          <p-button label="Añadir email saliente" *ngIf="allowWrite" icon="pi pi-plus" (click)="editContractOutgoingMail(null)"></p-button>
          </div>
        </ng-template>
        <div>
          <p-table styleClass="mt-2" #grid [value]="contractOutgoingMails" [paginator]="true" [rows]="25"
            [totalRecords]="totalContractCaseLogsRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="caseLogType.name">Tipo <p-sortIcon field="caseLogType.name"></p-sortIcon></th>
                <th pSortableColumn="mailAccount.username">Cuenta de correo remitente <p-sortIcon
                    field="caseLogType.name"></p-sortIcon></th>
                <th pSortableColumn="mailTo">Email de envío <p-sortIcon field="mailTo"></p-sortIcon></th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractOutgoingMail let-columns="columns">
              <tr (dblclick)="editContractOutgoingMail(contractOutgoingMail)">
                <td>
                  <div *ngIf="contractOutgoingMail.outgoingMailResourceType=='PhotoReport'">Informe fotográfico</div>
                  <div *ngIf="contractOutgoingMail.outgoingMailResourceType=='Invoice'">Facturas</div>
                  <div *ngIf="contractOutgoingMail.outgoingMailResourceType=='IncomingInvoice'">Auto facturas</div>
                  <div *ngIf="contractOutgoingMail.outgoingMailResourceType=='Budget'">Presupuesto</div>
                  <div *ngIf="contractOutgoingMail.outgoingMailResourceType=='Other'">Otros</div>

                </td>
                <td>{{contractOutgoingMail.mailAccount.username}}</td>
                <td>{{contractOutgoingMail.mailTo}}</td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteContractOutgoingMail(contractOutgoingMail)" [rounded]="true"
                      [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editContractOutgoingMail(contractOutgoingMail)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>
    </p-tabPanel>
    <p-tabPanel header="Especialidades" *ngIf="contract.id">
      <div class="flex justify-content-end">
        <p-button label="Añadir especialidad" *ngIf="allowWrite" icon="pi pi-plus"
          (click)="editContractCapability(null)"></p-button>
      </div>
      <p-table styleClass="mt-4" #grid [value]="contractCapabilities" [paginator]="true" [rows]="25"
        [totalRecords]="totalCapabilitiesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
             <th pSortableColumn="normalServiceAllowed">Horario normal <p-sortIcon field="normalServiceAllowed"></p-sortIcon></th>
            <th pSortableColumn="guardServiceAllowed">Horario de guardia <p-sortIcon field="guardServiceAllowed"></p-sortIcon></th>
            <th pSortableColumn="guardPercentIncrement">Incremento por guardia <p-sortIcon field="guardPercentIncrement"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractCapability let-columns="columns">
          <tr >
            <td>{{contractCapability.capability.name}}</td>
            <td>
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': contractCapability.normalServiceAllowed, 'text-red-500 pi-times-circle': !contractCapability.normalServiceAllowed }"></i>
            </td>
            <td>
                <i class="pi"[ngClass]="{ 'text-green-500 pi-check-circle': contractCapability.guardServiceAllowed, 'text-red-500 pi-times-circle': !contractCapability.guardServiceAllowed }"></i>
            </td>
            <td>{{contractCapability.guardPercentIncrement??0}} %</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteContractCapability(contractCapability)" [rounded]="true"
                  [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
               <!--<p-button *ngIf="allowWrite" (click)="editContractCapability(contractCapability)" [rounded]="true"
                  [text]="false"><i class="pi pi-pencil"></i></p-button>-->
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Zonas" *ngIf="contract.id">
      <div class="flex justify-content-end pb-1">
        <p-button label="Nueva zona" (click)="editContractZone({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table #grid styleClass="m-1 mt-4" [value]="contractZones" [loading]="loading" [paginator]="false"
        [scrollable]="true" scrollHeight="flex" [paginator]="true" [rows]="25"
        [totalRecords]="totalZonesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractZone let-columns="columns">
          <tr (dblclick)="editContractZone(contractZone)">
            <td>{{contractZone.zone?.name}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteContractZone(contractZone)"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado zonas
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Tramitadores">
      <div class="flex justify-content-end pb-1">
        <p-button label="Nuevo tramitador" (click)="editContractProcessor({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table #grid styleClass="m-1 mt-4" [value]="contractProcessors" [loading]="loading" [paginator]="false"
        [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>Usuario</th>
            <th width="100">% Carga</th>
            <th width="100">Vip</th>
            <th>Tipo de daño</th>
            <th width="100">Sin definir</th>
            <th width="100">Recibir llamadas</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractProcessor let-columns="columns">
          <tr (dblclick)="editContractProcessor(contractProcessor)">
            <td>
              {{contractProcessor.processor?.name}}
              <span *ngIf="!contractProcessor.processor?.active" class="mt-2" class="text-danger"><br>(Inactivo)</span>            
            </td>
            <td>{{contractProcessor.maxLoadChargePercent}}</td>
            <td>{{contractProcessor.vipCase?'Si':(contractProcessor.vipCase== null ? 'Todos':'No')}}</td>
            <td>{{contractProcessor.allCasesTypes?'Todos':showCaseTypesNames(contractProcessor.id)}}</td>
            <td>
              <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': contractProcessor.allowWithoutCaseType, 'text-red-500 pi-times-circle': !contractProcessor.allowWithoutCaseType }"></i>
            </td>
            <td>
              <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': contractProcessor.enableIncomingCalls, 'text-red-500 pi-times-circle': !contractProcessor.enableIncomingCalls }"></i>
            </td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDeleteProcessors" (click)="deleteContractProcessor(contractProcessor)"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWrite" (click)="editContractProcessor(contractProcessor)"
                  styleClass="p-button-xs"><i class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado tramitadores
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Operarios preferentes" *ngIf="contract.id">
      <div class="flex justify-content-end pb-1">
        <p-button label="Nuevo operario" (click)="editContractWorker({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table #grid styleClass="m-1 mt-4" [value]="contractWorkers" [loading]="loading" [paginator]="false"
        [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>Operador</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractWorker let-columns="columns">
          <tr (dblclick)="editContractWorker(contractWorker)">
            <td>{{contractWorker.worker.name}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteContractWorker(contractWorker)"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWrite" (click)="editContractWorker(contractWorker)" styleClass="p-button-xs"><i
                    class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado operarios preferentes
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="SLAs" *ngIf="contract.id">
      <div class="flex justify-content-end pb-1">
        <p-button label="Nuevo SLAs" (click)="editContractSla(null)" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table #grid styleClass="m-1 mt-4" [value]="contractSlas" [loading]="loading" [paginator]="false"
        [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>Tipo de evento</th>
            <th>Horas</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractSla let-columns="columns">
          <tr (dblclick)="editContractSla(contractSla)">
            <td>{{contractSla.caseEventType?.name}}</td>
            <td>{{contractSla.hours}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteContractSla(contractSla)" [rounded]="true" [text]="false"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWrite" (click)="editContractSla(contractSla)" [rounded]="true" [text]="false"
                  styleClass="p-button-xs"><i class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado resultados
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <!--<p-tabPanel header="Cuentas de correo" *ngIf="contract.id">
      <div class="flex justify-content-end pb-1">
        <p-button label="Nuevo correo" (click)="editContractMailAccount(null)" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table #grid styleClass="m-1 mt-4" [value]="contractMailAccounts" [loading]="loading" [paginator]="false"
        [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>Nombre</th>
            <th>Nombre de usuario</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractMailAccount let-columns="columns">
          <tr (dblclick)="editContractMailAccount(contractMailAccount)">
            <td>{{contractMailAccount.name}}</td>
            <td>{{contractMailAccount.username}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteContractMailAccount(contractMailAccount)" [rounded]="true"
                  [text]="false" styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWrite" (click)="editContractMailAccount(contractMailAccount)" [rounded]="true"
                  [text]="false" styleClass="p-button-xs"><i class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado resultados
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>-->
    <p-tabPanel header="Baremos" [disabled]="!contract.id">
      <p-table styleClass="mt-4" [value]="rates" [paginator]="true" [rows]="25" [totalRecords]="totalRatesRecords"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="rate.name">Baremo <p-sortIcon field="rate.name"></p-sortIcon></th>
            <th pSortableColumn="insuranceCompany.name">Compañia aseguradora <p-sortIcon field="insuranceCompany.name"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-workerRate let-columns="columns">
          <tr>
            <td>{{workerRate.rate.name}}</td>
            <td>{{(workerRate.insuranceCompany!=null?workerRate.insuranceCompany?.name:'Todas')}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado resultados
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Categorias de eventos" [disabled]="!contract.id">
      <div class="flex justify-content-end pb-1">
        <p-button label="Añadir" (click)="addCaseLogType()" styleClass="p-button-sm" *ngIf="allowWrite"></p-button>
      </div>
      <p-table styleClass="mt-4" [value]="caseLogTypesContract" [paginator]="true" [rows]="25"
        [totalRecords]="totalRatesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="rate.name">Tipo <p-sortIcon field="rate.name"></p-sortIcon></th>
            <th width="150" *ngIf="allowCaseLogTypeFields">Campos propios</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-caseLogTypeContract let-columns="columns">
          <tr>
            <td>{{caseLogTypeContract.caseLogType.name}}</td>
            <td *ngIf="allowCaseLogTypeFields">
              <p-tag *ngIf="caseLogTypeContract.fieldsConfiguration" severity="success" value="Sí"></p-tag>
              <span *ngIf="!caseLogTypeContract.fieldsConfiguration">No</span>
            </td>
            <td>
                <div class="flex gap-1">
                  <p-button *ngIf="allowWrite && allowCaseLogTypeFields" (click)="editCaseLogTypeFields(caseLogTypeContract)" [rounded]="true"
                    [text]="false" styleClass="p-button-xs" pTooltip="Editar campos a rellenar"><i class="pi pi-pencil"></i></p-button>
                  <p-button *ngIf="allowDelete" (click)="deleteCaseLogType(caseLogTypeContract)" [rounded]="true"
                    [text]="false" styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="allowCaseLogTypeFields ? 3 : 2">
              No se han encontrado resultados
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Notas" [disabled]="!contract.id">
      <div class="">
        <p-editor name="name" formControlName="notes" d-form-field-error [style]="{ height: '320px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Negrita"></button>
              <button type="button" class="ql-italic" aria-label="Cursiva"></button>
              <button type="button" class="ql-underline" aria-label="Subrayado"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color" aria-label="Color"></select>
              <select class="ql-background" aria-label="Color de fondo"></select>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered" aria-label="Lista de números"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Lista de puntos"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-link" aria-label="Enlace"></button>
              <select class="ql-align" aria-label="Alineación"></select>
            </span>
          </ng-template>
        </p-editor>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Integración" [disabled]="!contract.id">
      <div class="grid">
        <div class="col-12 input-field">
          <label for="name">Integración</label>
          <p-dropdown name="integrationId" [options]="integrations" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" placeholder="Seleccione integración" appendTo="body"
            formControlName="integrationId" d-form-field-error (onChange)="changeIntegration()" />
        </div>
        <ng-container *ngFor="let group of integration_groups">
          <ng-container *ngIf="!group.name" [ngTemplateOutlet]="integrationFieldsTpl"
            [ngTemplateOutletContext]="{fields: group.fields}"></ng-container>
          <div class="col-12" *ngIf="group.name">
            <p-card [header]="group.name">
              <div class="grid">
                <ng-container [ngTemplateOutlet]="integrationFieldsTpl"
                  [ngTemplateOutletContext]="{fields: group.fields}"></ng-container>
              </div>
            </p-card>
          </div>
        </ng-container>
      </div>

      <ng-template #integrationFieldsTpl let-fields="fields">
        <ng-container *ngFor="let config of fields">
          <div class="col-2 input-field" *ngIf="config.type=='text'">
            <label for="{{config.code}}">{{config.label}}</label>
            <input pInputText name="{{config.code}}" [(ngModel)]="localModel[config.code]" [ngModelOptions]="{standalone: true}"  d-form-field-error />
          </div>
          <div class="col-2 input-field" *ngIf="config.type=='password'">
            <label for="{{config.code}}">{{config.label}}</label>
            <p-password name="{{config.code}}" [(ngModel)]="localModel[config.code]" [ngModelOptions]="{standalone: true}"
              [toggleMask]="true" [feedback]="false" autocomplete="new-password" d-form-field-error />
          </div>
          <div class="col-12" *ngIf="config.type=='mail_account' && localModel[config.code]"
            [class.mail-account-disabled]="!localModel[config.code].enabled">
            <p-panel>
              <ng-template pTemplate="header">
                <div class="p-panel-title w-full flex align-items-center pb-0 gap-2">
                  <div>{{config.label}}</div>
                  <div class="flex-grow-1"></div>
                  <p-inputSwitch name="{{config.code}}_enabled" [(ngModel)]="localModel[config.code].enabled" [ngModelOptions]="{standalone: true}" />
                </div>
              </ng-template>

              <div class="grid" *ngIf="localModel[config.code].enabled">
                <div class="col-3 input-field">
                  <label for="{{config.code}}_email">Correo electrónico</label>
                  <input pInputText type="email" name="{{config.code}}_email" [(ngModel)]="localModel[config.code].email" [ngModelOptions]="{standalone: true}" d-form-field-error />
                </div>
                <div class="col-2 input-field">
                  <label for="{{config.code}}_username">Usuario</label>
                  <input pInputText name="{{config.code}}_username" [(ngModel)]="localModel[config.code].username" [ngModelOptions]="{standalone: true}" d-form-field-error />
                </div>
                <div class="col-2 input-field">
                  <label for="{{config.code}}_password">Contraseña</label>
                  <p-password name="{{config.code}}_password" [(ngModel)]="localModel[config.code].password" [ngModelOptions]="{standalone: true}"
                    [toggleMask]="true" [feedback]="false" autocomplete="new-password" d-form-field-error />
                </div>
                <div class="col-3 input-field">
                  <label for="{{config.code}}_host">Servidor</label>
                  <input pInputText name="{{config.code}}_host" [(ngModel)]="localModel[config.code].host" [ngModelOptions]="{standalone: true}" d-form-field-error />
                </div>
                <div class="col-1 input-field">
                  <label for="{{config.code}}_port">Puerto</label>
                  <input pInputText type="number" name="{{config.code}}_port" [(ngModel)]="localModel[config.code].port" [ngModelOptions]="{standalone: true}" d-form-field-error />
                </div>
                <div class="col-1 input-field">
                  <label for="{{config.code}}_ssl">Usar SSL</label>
                  <p-inputSwitch name="{{config.code}}_ssl" [(ngModel)]="localModel[config.code].ssl" [ngModelOptions]="{standalone: true}" d-form-field-error />
                </div>
              </div>
            </p-panel>
          </div>
        </ng-container>
      </ng-template>
    </p-tabPanel>


    <p-tabPanel header="Tipos de daño" [disabled]="!contract.id">
      <p-table styleClass="mt-4" [value]="contractCaseTypes" [paginator]="true" [rows]="25" [totalRecords]="totalContractCaseTypesRecords"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
        (onEditComplete)="saveContractCaseType($event)">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="caseType.name">Tipo de daño <p-sortIcon field="caseType.name"></p-sortIcon></th>
            <th pSortableColumn="daysGuarantes">Dias de garantía <p-sortIcon field="daysGuarantes"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contractCaseType let-columns="columns">
          <tr>
            <td>{{contractCaseType.caseType.name}}</td>
            <td pEditableColumn  
                [pEditableColumn]="contractCaseType.daysGuarantes"
                [pEditableColumnField]="contractCaseType.caseType"
                [pEditableColumnRowIndex]="contractCaseType.id" >
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="number"  [(ngModel)]="contractCaseType.daysGuarantes" [ngModelOptions]="{standalone: true}"  />
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ contractCaseType.daysGuarantes }}
                        </ng-template>
                    </p-cellEditor>
                </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado tipos de daños.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

  </p-tabView>

</form>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Tipo de evento" [(visible)]="displaycaseLogType" [modal]="true" [closable]="false"
  [style]="{width: '500px'}">

  <div class="pt-3 flex flex-column gap-2">
    <div class="input-field">
      <label for="caseLogTypeId">Tipo de evento</label>
      <p-dropdown [(ngModel)]="caseLogTypeId" [options]="caseLogTypesFiltered" optionLabel="name" optionValue="id"
        appendTo="body" placeholder="Selecciona tipo evento" showClear styleClass="sm"></p-dropdown>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="pt-3">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
        (click)="displaycaseLogType=false"></button>
      <button pButton label="Guardar" icon="pi pi-save" (click)="saveCaseLogType()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Campos a rellenar" *ngIf="allowCaseLogTypeFields" [(visible)]="displayCaseLogTypeFields" [modal]="true" [closable]="false"
  [style]="{width: '700px'}">

  <div class="pt-3 flex flex-column gap-2">
    <div class="input-field">
      <label for="fieldsConfiguration">Configuración de campos (JSON)</label>
      <textarea pInputTextarea [(ngModel)]="caseLogTypeFieldsConfiguration" [ngModelOptions]="{standalone: true}"
        rows="14" style="font-family: monospace;"></textarea>
      <span>Objeto JSON con una lista "fields". Sustituye por completo al formulario definido en la categoría; vacío significa usar el de la categoría.</span>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="pt-3">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
        (click)="displayCaseLogTypeFields=false"></button>
      <button pButton label="Guardar" icon="pi pi-save" (click)="saveCaseLogTypeFields()"></button>
    </div>
  </ng-template>
</p-dialog>